<template>
  <div class="dashboard-page">
    <v-container class="mt-10">
      <v-row class="vertical-core-align main-core-container">
        <v-col md="12">
          <v-card
            max-width="600"
            class="mx-auto"
          >
            <v-container class="pa-1">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  align="center"
                  class="home-core-button"
                  @click="goToLiftBook()"
                >
                  <v-icon
                    class="home-core-icon"
                    color="primary"
                  >
                    elevator
                  </v-icon>
                  {{$t('core-site:landing.liftbook')}}
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  align="center"
                  class="home-core-button"
                  @click="goToDisplay()"
                >
                  <v-icon
                    class="home-core-icon"
                    color="primary"
                  >
                    monitor
                  </v-icon>
                  {{$t('core-site:landing.display')}}
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import {Role} from "@/modules/core/data/roles";
import Vue from "vue";

export default {
  name: 'LandingPage',
  components: {},
  computed: {
    isDashboardVisible() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin)
            || this.currentUser.roles.includes(Role.ViewEmployee);
      }
      return false;
    },
    isFacilityManager() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.FacilityManager);
      }
      return false;
    },
    isMasterUser() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Master);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    goToLiftBook() {
      window.location.replace(`/${this.$store.state.manager.bookModuleUrl}`);
    },
    goToDisplay() {
      if (!this.currentUser) {
        localStorage.setItem('landing-page-need-redirect', 1);
      }
      this.redirect();
    },
    redirect() {
      if (this.isDashboardVisible) {
        this.$router.push(`/${this.$store.state.manager.displayModuleUrl}`);
      } else if (this.isFacilityManager) {
        this.$router.push(`/${this.$store.state.manager.displayModuleUrl}/elevator`);
      } else if(this.currentUser) {
        this.$router.push(`/${this.$store.state.manager.displayModuleUrl}/offer`);
      } else {
        window.location.replace(Vue.$keycloak.createLoginUrl());
      }
    }
  },
  created() {
    let needsRedirect = localStorage.getItem('landing-page-need-redirect');
    if (needsRedirect == 1) {
      localStorage.setItem('landing-page-need-redirect', 0);
      this.redirect();
    }
  }
}
</script>

<style>
.vertical-core-align {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.main-core-container {
  height: 600px;
}

.home-core-button {
  cursor: pointer;
}

.home-core-button .home-core-icon {
  font-size: 140px;
}

@media only screen and (max-height: 600px) {
  .main-core-container {
    height: 400px;
  }
}

@media only screen and (max-height: 400px) {
  .main-core-container {
    height: 300px;
  }
}
</style>